import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';
import Filter from 'Components/Common/Filter';
const ConstPoolAndPond = () => {
  document.title = "Усан сан, хөв цөөрөм";

  const [searchField, setSearchField] = useState<any>();

  useEffect(() => {
  }, [searchField])


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Усны барилга байгууламж" breadcrumbItem="Усан сан, хөв цөөрөм" />
          <Row>
            <Filter setSearchField={setSearchField} f_basin_code={true} f_au1_code={true} f_au2_code={true} f_au3_code={true} f_name={true} f_code={true} f_save_border={true} f_commonType={'cmn_pool_type'} />
            <Detail searchField={searchField} />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default ConstPoolAndPond;